import { Button } from "../ui/Button";
import heroImage from "../../assets/hero-image.jpg";

export const HeroSection = ({ onExplore, onLearnMore }) => {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-gray-50 via-blue-50/20 to-purple-50/10 pt-16 hero-mobile">
      <div className="max-w-7xl mx-auto container-mobile section-mobile">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="mobile-heading-1 hero-text-mobile">
                Travel{" "}
                <span className="bg-gradient-to-r from-teal-600 to-red-400 bg-clip-text text-transparent">
                  Fearlessly
                </span>
                .<br />
                Explore{" "}
                <span className="bg-gradient-to-r from-red-400 to-purple-400 bg-clip-text text-transparent">
                  Confidently
                </span>
                .
              </h1>
              <p className="mobile-body-text max-w-lg">
                Crowdsourced safety information empowering women travelers worldwide. 
                Real insights from real women who've been there before.
              </p>
            </div>

            <div className="hero-buttons-mobile">
              <Button 
                variant="hero" 
                size="xl" 
                onClick={onExplore}
                className="btn-mobile transform transition-all duration-300 hover:scale-105"
              >
                Start Exploring Safely
              </Button>
              <Button 
                variant="heroOutline" 
                size="xl" 
                onClick={onLearnMore}
                className="btn-mobile transform transition-all duration-300 hover:scale-105"
              >
                Learn More
              </Button>
            </div>

            <div className="flex items-center space-x-8 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <span>Verified Reviews</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                <span>Global Community</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-purple-400 rounded-full"></div>
                <span>Real-time Updates</span>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-teal-600/20 to-red-400/20 rounded-2xl transform rotate-6"></div>
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src={heroImage}
                alt="Confident woman traveler exploring city with smartphone map"
                className="w-full h-full object-cover"
                onError={(e) => {
                  // Fallback if hero image doesn't load
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTgiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIiBmaWxsPSIjOTk5Ij5TYWZlU29sbyBUcmF2ZWw8L3RleHQ+PC9zdmc+';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};